import { render } from "./educationalOfflineInfo.vue?vue&type=template&id=4754b6fa&scoped=true"
import script from "./educationalOfflineInfo.vue?vue&type=script&lang=js"
export * from "./educationalOfflineInfo.vue?vue&type=script&lang=js"

import "./educationalOfflineInfo.vue?vue&type=style&index=0&id=4754b6fa&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4754b6fa"]])

export default __exports__